<script setup lang="ts">
useSeoMeta({
  title: "Blog - Bali Bikes Island",
  ogTitle: "Blog - Bali Bikes Island",
  description: "Stay updated with the latest news, tips, and stories about motorbike rentals in Bali. Explore our blog for useful insights on Bali adventures, travel tips, and more.",
  ogDescription: "Catch up on the latest articles and travel insights from Bali Bikes Island. Our blog provides helpful tips, bike rental advice, and updates on Bali's best motorcycle routes.",
  ogImage: "/assets/logo-bali-bikes-main.png",
});

useHead({
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "Blog - Bali Bikes Island",
        "url": "https://balibikesisland.com/blog",
        "description": "Get useful travel tips, scooter safety info, and Bali insights from the Bali Bikes Island blog.",
      }),
    },
  ],
});

const router = useRouter();
</script>

<template>
    <PageBlog />
</template>
